import React from "react";

function Work() {
  return (
    <div id="landing-work">
      <h3>CV is a resume maker </h3>
      <p>
        It all started in 2022, when we launched a small web app that built
        online documents such as cancellation letters and basic CVs. A couple
        months after launching we noticed a strange trend; most people were
        visiting our site just to build CVs. In an effort to deliver more value
        to our users, we decided to specialize in just cv-building. Knowing that
        hiring managers nowadays are stricter than ever; we devoted countless
        hours to studying job-winning CVs, getting CV templates critiqued by
        experts and testing our CV content through the grueling process of trial
        & error. The result? We figured out that building a job-winning CV is a
        science, not art. We learned there’s an exact structure and set of ‘CV
        rules’ that hiring managers respond to when it comes to calling back
        applicants. Since then, we launched Resume.io, which uses these exact
        job-winning CV structures and ‘CV rules’ to give you the edge over your
        competition so you get hired faster. Up to now, we’ve helped over
        15,000,000 people successfully build job-winning CV, as well as helping
        countless others win jobs at elite companies such as PWC, BMW and
        T-Mobile.
      </p>
    </div>
  );
}

export default Work;
